import api from './client';

// Payroll (from the accountants' emails) and tax debts (Fan, 2026-10-27)
export const payrollAPI = {
  getOverview: (entityId) => api.get('/payroll/overview', { params: { entity_id: entityId }, timeout: 60000 }),
  scan: () => api.post('/payroll/scan', null, { timeout: 300000 }),
  getVatReturns: (params) => api.get('/payroll/vat-returns', { params, timeout: 60000 }),
  getVatReturnFile: (id, index) => api.get(`/payroll/vat-returns/${encodeURIComponent(id)}/file/${index}`, { responseType: 'blob', timeout: 60000 }),
  getTaxObligationFile: (id, index) => api.get(`/payroll/tax-obligations/${encodeURIComponent(id)}/file/${index}`, { responseType: 'blob', timeout: 60000 }),
  getFile: (runId, kind) => api.get(`/payroll/runs/${runId}/file/${kind}`, { responseType: 'blob', timeout: 60000 }),
};
